import { SeatsioSeatingChart } from "@seatsio/seatsio-react"
import { useBookingV2 } from "context/BookingV2Context"
import { useCartDispatch, useCartState } from "hooks/useCartV2"
import { useEffect, useState, useMemo } from "react"
import { SelectedSeat, SelectedTickets } from "types/Booking"

export interface ChartInstance {
    selectedObjects: string[]
    selectedSeats: string[]
}
export interface ChartCategory {
    label: string
    key: number
}
export interface ChartMainObject {
    category: ChartCategory
    id: string
    chart: ChartInstance
    uuid: string
    seatId: string
}

const SelectSeat = () => {
    const { event } = useBookingV2()
    const cartState = useCartState()
    const cartDispatch = useCartDispatch()

    const cartContext = useCartState()

    const [chart, setChart] = useState({})

    const availableCategories = useMemo(() => {
        return cartState.selectedTickets
            ?.map((ticket: SelectedTickets) => ticket.en_title)
            .filter((item: string) => item !== undefined)
            .filter(
                (item: string, index: number, array: string[]) =>
                    array.indexOf(item) === index
            )
    }, [cartState.selectedTickets])

    const maxSelectionAllowed = useMemo(() => {
        return availableCategories?.map((item) => ({
            category: item,
            quantity: 1,
        }))
    }, [availableCategories])

    const [countdown, setCountdown] = useState(0)

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
            return () => clearTimeout(timer)
        }
    }, [countdown])

    const [selectedSeatsLabels, setSelectedSeatsLabels] = useState<
        Array<string>
    >([])

    useEffect(() => {
        setSelectedSeatsLabels(
            cartContext.selectedSeats
                .map((seat: SelectedSeat) => seat.id)
                .filter((item: string) => item !== undefined)
        )
    }, [cartContext.selectedSeats])
    if (
        !event ||
        !event.seatsio.season_id ||
        !cartState.selectedDays?.seats_season_id
    ) {
        return null
    }

    /*
    get user_channel field
    pass it to the seatsio component
    seats_channel: {
        user_channel: string
    }
    */

    return (
        <div className="relative container flex gap-5 items-center justify-center">
            <div className="flex">
                <div className=" w-screen max-w-screen-md">
                    <SeatsioSeatingChart
                        fitTo="width"
                        availableCategories={availableCategories}
                        selectedObjects={selectedSeatsLabels}
                        showFullScreenButton={false}
                        selectableObject={selectedSeatsLabels}
                        region="eu"
                        language="ar"
                        workspaceKey={
                            process.env.NEXT_PUBLIC_SEATS_WORKSPACE_KEY
                        }
                        event={cartContext?.selectedDays?.seats_season_id}
                        onObjectSelected={(o: any) => {
                            cartDispatch({
                                type: "ADD_SEATS",
                                payload: {
                                    id: o?.id,
                                    label: o?.category.label,
                                },
                            })
                        }}
                        //   @ts-ignore
                        onObjectDeselected={(o: ChartMainObject) => {
                            cartDispatch({
                                type: "REMOVE_SEAT",
                                payload: {
                                    id: o.id,
                                    label: o.category.label,
                                },
                            })
                        }}
                        onSelectedObjectBooked={(o) => {
                            setChart({ ...chart, ...o })
                        }}
                        maxSelectedObjects={maxSelectionAllowed}
                    />
                </div>
            </div>
        </div>
    )
}

export default SelectSeat
